import { render, staticRenderFns } from "./relate-delivery.vue?vue&type=template&id=bb7640b2&scoped=true&"
import script from "./relate-delivery.vue?vue&type=script&lang=js&"
export * from "./relate-delivery.vue?vue&type=script&lang=js&"
import style0 from "./relate-delivery.vue?vue&type=style&index=0&id=bb7640b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7640b2",
  null
  
)

export default component.exports